function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("style", null, ".cSharp_svg__st1{fill:#6a1577}.cSharp_svg__st3{fill:#fff}");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "cSharp_svg__XMLID_3_",
  d: "M412.4 174.8c0-6.1-1.3-11.6-4-16.2-2.6-4.6-6.5-8.4-11.7-11.4-43.2-24.9-86.5-49.8-129.7-74.7-11.7-6.7-22.9-6.5-34.5.3-17.2 10.1-103.4 59.5-129 74.4-10.6 6.1-15.7 15.5-15.7 27.7v150.4c0 6 1.3 11.3 3.8 15.9 2.6 4.7 6.6 8.7 11.9 11.8 25.7 14.9 111.8 64.2 129 74.4 11.6 6.8 22.9 7.1 34.5.3 43.2-25 86.5-49.8 129.7-74.7 5.4-3.1 9.3-7 11.9-11.8 2.5-4.6 3.8-9.9 3.8-15.9V174.8",
  fill: "#9a4993"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  id: "cSharp_svg__XMLID_4_",
  className: "cSharp_svg__st1",
  d: "M250.5 249.5L91.4 341.1c2.6 4.7 6.6 8.7 11.9 11.8 25.7 14.9 111.8 64.2 129 74.4 11.6 6.8 22.9 7.1 34.5.3 43.2-25 86.5-49.8 129.7-74.7 5.4-3.1 9.3-7 11.9-11.8l-157.9-91.6"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  id: "cSharp_svg__XMLID_5_",
  className: "cSharp_svg__st1",
  d: "M203.4 276.6c9.3 16.2 26.7 27.1 46.6 27.1 20.1 0 37.6-11 46.8-27.4l-46.3-26.8-47.1 27.1"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  id: "cSharp_svg__XMLID_6_",
  d: "M412.4 174.8c0-6.1-1.3-11.6-4-16.2l-157.9 90.9 158.1 91.6c2.5-4.6 3.8-9.9 3.8-15.9V174.8",
  fill: "#813084"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  id: "cSharp_svg__XMLID_9_",
  className: "cSharp_svg__st3",
  d: "M296.8 276.3c-9.2 16.3-26.7 27.4-46.8 27.4-20 0-37.4-10.9-46.6-27.1-4.5-7.9-7.1-16.9-7.1-26.6 0-29.7 24-53.7 53.7-53.7 19.8 0 37.1 10.8 46.4 26.8l46.9-27c-18.7-32.2-53.5-53.9-93.4-53.9-59.6 0-107.8 48.3-107.8 107.8 0 19.5 5.2 37.9 14.3 53.7C175 336 210 357.8 250 357.8c40.1 0 75.1-21.9 93.7-54.4l-46.9-27.1"
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  id: "cSharp_svg__XMLID_32_"
}, React.createElement("path", {
  id: "cSharp_svg__XMLID_2_",
  className: "cSharp_svg__st3",
  d: "M345.4 224.5h10.7v51.7h-10.7z"
}), React.createElement("path", {
  id: "cSharp_svg__XMLID_30_",
  className: "cSharp_svg__st3",
  d: "M369.1 224.5h10.7v51.7h-10.7z"
}), React.createElement("path", {
  id: "cSharp_svg__XMLID_31_",
  className: "cSharp_svg__st3",
  d: "M336.8 233.2h51.7v10.7h-51.7z"
}), React.createElement("path", {
  id: "cSharp_svg__XMLID_23_",
  className: "cSharp_svg__st3",
  d: "M336.8 256.8h51.7v10.7h-51.7z"
}));

var SvgCSharp = function SvgCSharp(props) {
  return React.createElement("svg", _extends({
    id: "cSharp_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    width: 500,
    height: 500,
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

export default "data:image/svg+xml;base64,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";
export { SvgCSharp as ReactComponent };